import { useCallback, useRef } from 'react';
import { useUpdateTasksMutation } from 'shared/hooks/queries/use-update-tasks-mutation';
import { UpdateTask } from 'shared/types/task';

export const useUpdateTasks = () => {
  const updateTasksRef = useRef<UpdateTask[]>();
  const {
    mutate: updateTasks,
    error,
    isPending,
    isSuccess,
    reset,
  } = useUpdateTasksMutation();

  const submit = useCallback(
    (tasks: UpdateTask[]) => {
      updateTasksRef.current = tasks;
      updateTasks(tasks);
    },
    [updateTasks],
  );

  const retry = useCallback(() => {
    const tasks = updateTasksRef.current;

    if (tasks) {
      updateTasks(tasks);
    }
  }, [updateTasks]);

  const resetAll = useCallback(() => {
    reset();
    updateTasksRef.current = undefined;
  }, [reset]);

  return {
    submit,
    retry,
    reset: resetAll,
    error,
    isLoading: isPending,
    isSuccess,
  };
};
